export type ConnectorAuthorizationPlan = {
  reauthorizeOffice: boolean;
};

export const PENDING_FEISHU_OFFICE_CONNECTION_KEY = "pending-feishu-office-connection";

export type PendingFeishuOfficeConnection = {
  id: string;
  name: string;
};

export function connectorAuthorizationPlan(authType: string): ConnectorAuthorizationPlan {
  return { reauthorizeOffice: authType === "user_session" };
}

export function shouldUseFeishuAuthorizationEntry(pathname: string) {
  return pathname !== "/agents";
}

export function savePendingFeishuOfficeConnection(
  storage: Pick<Storage, "setItem">,
  connector: PendingFeishuOfficeConnection
) {
  storage.setItem(PENDING_FEISHU_OFFICE_CONNECTION_KEY, JSON.stringify(connector));
}

export function consumePendingFeishuOfficeConnection(
  storage: Pick<Storage, "getItem" | "removeItem">
): PendingFeishuOfficeConnection | undefined {
  const raw = storage.getItem(PENDING_FEISHU_OFFICE_CONNECTION_KEY);
  storage.removeItem(PENDING_FEISHU_OFFICE_CONNECTION_KEY);
  if (!raw) return undefined;
  try {
    const parsed = JSON.parse(raw) as Partial<PendingFeishuOfficeConnection>;
    if (typeof parsed.id !== "string" || !/^[0-9a-f-]{36}$/i.test(parsed.id)) return undefined;
    if (typeof parsed.name !== "string" || parsed.name.length < 1 || parsed.name.length > 100) return undefined;
    return { id: parsed.id, name: parsed.name };
  } catch {
    return undefined;
  }
}
